import { clearLogin } from "../../store/actions/login";
import { GetAccessToken } from "../authentication";
import axios from "axios";

function appendFormData(formData, data, state, parentKey = '') {
  if (typeof data === 'object' && data !== null && !(data instanceof File)) {
    // ✅ Special case: array of files
    if (Array.isArray(data) && data.length && data[0] instanceof File) {
      state.isUploading = true;
      // always use parentKey (no [0])
      formData.append(parentKey, data[0]);
      return;
    }

    // ✅ Normal object/array case
    Object.entries(data).forEach(([key, value]) => {
      const newKey = parentKey ? `${parentKey}[${key}]` : key;

      if (value instanceof File) {
        state.isUploading = true;
        // for single file, always use its plain key (not with [index])
        const fileKey = parentKey || key;
        formData.append(fileKey, value);
        return;
      }

      appendFormData(formData, value, state, newKey);
    });
  } else {
    formData.append(parentKey, data);
  }
}


const postData = async (fields, url, dispatch, navigate, headers) => {
  try {
    let token = GetAccessToken();
    const formData = new FormData();
    const state = { isUploading: false };

    console.log("postData fields:", fields);

    appendFormData(formData, fields, state);

    console.log("postData formData:", formData);

    const hasQuery = url.includes("?");
    const response = await axios.post(
      `${process.env.REACT_APP_API}${url}${hasQuery ? "&" : "?"}lang=${sessionStorage.getItem("_lang") ? sessionStorage.getItem("_lang") : "de" }`,
      state.isUploading ? formData : JSON.stringify(fields),
      {
        headers: {
          "Content-Type": state.isUploading
            ? "multipart/form-data"
            : "application/json",
          "x-access-token": token,
          ...((sessionStorage.getItem("selected-company") && sessionStorage.getItem("user") && JSON.parse(sessionStorage.getItem("user")).user.authorisation === "advisor" && JSON.parse(sessionStorage.getItem("user")).user.company && JSON.parse(sessionStorage.getItem("user")).user.company !== null)
            ? { "x-company-id": sessionStorage.getItem("selected-company") }
            : {}),
          ...(headers ? headers : {}),
        },
      }
    );

    if (response.status === 401) {
      try {
        dispatch(clearLogin());
        navigate("/");
        navigate(0);
      } catch (error) {}
    }

    return { status: response.status, data: response.data };
  } catch (error) {
    console.log("error", error);
    return {
      status: error.response?.status ?? error,
      data: error.response?.data?.message,
    };
  }
};


const bulkUploadData = async (fieldsArray, url, dispatch, navigate) => {
  const data = new Promise(async (resolve, reject) => {
    try {
      let token = GetAccessToken();
      const formData = new FormData();
      const state = { isUploading: false };

      console.log("fieldsArray in bulk upload:", fieldsArray);

      // ✅ Loop through array elements and append each item properly
      if (Array.isArray(fieldsArray)) {
        fieldsArray.forEach((item, index) => {
          appendFormData(formData, item, state, `data[${index}]`);
        });
      } else {
        appendFormData(formData, fieldsArray, state);
      }

      const hasQuery = url.includes("?");
      const response = await axios.post(
        `${process.env.REACT_APP_API}${url}${hasQuery ? "&" : "?"}lang=${
          sessionStorage.getItem("_lang") ? sessionStorage.getItem("_lang") : "de"
        }`,
        formData,
        {
          headers: {
            "Content-Type": state.isUploading
              ? "multipart/form-data"
              : "application/json",
            "x-access-token": token,
            ...((sessionStorage.getItem("selected-company") && sessionStorage.getItem("user") && JSON.parse(sessionStorage.getItem("user")).user.authorisation === "advisor" && JSON.parse(sessionStorage.getItem("user")).user.company && JSON.parse(sessionStorage.getItem("user")).user.company !== null)
            ? { "x-company-id": sessionStorage.getItem("selected-company") }
            : {}),
          },
        }
      );

      if (response.status === 401) {
        try {
          dispatch(clearLogin());
          navigate("/");
          navigate(0);
        } catch (error) {
          // ignore navigation errors
        }
      }

      resolve({ status: response.status, data: response.data });
    } catch (error) {
      console.error("bulk upload error:", error);
      resolve({
        status: error.response?.status ?? error,
        data: error.response?.data?.message,
      });
    }
  });

  return data;
};


const putData = async (fields, ulr, dispatch, navigate, headers = null) => {
  const data = new Promise(async (resolve, reject) => {
    try {
      let token = GetAccessToken();
      const formData = new FormData();
      const state = { isUploading: false };

      appendFormData(formData, fields, state);
      // Check if ulr already contains a query string
      const hasQuery = ulr.includes("?");
      const response = await axios.put(`${process.env.REACT_APP_API}${ulr}${hasQuery ? "&" : "?"}lang=${sessionStorage.getItem("_lang") ? sessionStorage.getItem("_lang") : "de" }`, formData, {
        headers: {
          "Content-Type": state.isUploading ? "multipart/form-data" : "application/json",
          "x-access-token": token,
          ...((sessionStorage.getItem("selected-company") && sessionStorage.getItem("user") && JSON.parse(sessionStorage.getItem("user")).user.authorisation === "advisor" && JSON.parse(sessionStorage.getItem("user")).user.company && JSON.parse(sessionStorage.getItem("user")).user.company !== null)
            ? { "x-company-id": sessionStorage.getItem("selected-company") }
            : {}),
          ...(headers ? headers : {})
        },
      });
      if (response.status === 401) {
        try {
          dispatch(clearLogin());
          navigate("/");
          navigate(0);
        } catch (error) {
          // console.log(error);
        }
      }
      resolve({ status: response.status, data: response.data });
    } catch (error) {
      console.error(error);
      resolve({
        status: error.response?.status,
        data: error.response?.data?.message,
      });
    }
  });

  return data;
};
const getData = async (fields, ulr, dispatch, navigate, headers) => {
  const data = new Promise(async (resolve, reject) => {
    try {
      fields = { ...fields, lang: sessionStorage.getItem("_lang") ? sessionStorage.getItem("_lang") : "de" };
      let queryString = Object.keys(fields)
        .map((key) => key + "=" + encodeURIComponent(fields[key]))
        .join("&");
      let token = GetAccessToken();
      // Check if ulr already contains a query string
      const hasQuery = ulr.includes("?");
      const fullUrl = `${process.env.REACT_APP_API}${ulr}${hasQuery ? "&" : "?"}${queryString}`;
      const response = await axios.get(fullUrl, {
        headers: {
          "Content-Type": "application/json",
          "x-access-token": token,
          ...((sessionStorage.getItem("selected-company") && sessionStorage.getItem("user") && JSON.parse(sessionStorage.getItem("user")).user.authorisation === "advisor" && JSON.parse(sessionStorage.getItem("user")).user.company && JSON.parse(sessionStorage.getItem("user")).user.company !== null)
            ? { "x-company-id": sessionStorage.getItem("selected-company") }
            : {}),
          ...(headers ? headers : {})
        },
      });
      if (response.status === 401) {
        try {
          dispatch(clearLogin());
          navigate("/");
          navigate(0);
        } catch (error) {
          // console.log(error);
        }
      }
      resolve({ status: response.status, data: response.data });
    } catch (error) {
      if (error.response.status) {
        if (error.response.status === 401) {
          try {
            sessionStorage.removeItem("user");
            navigate("/");
            navigate(0);
          } catch (error) {
            // console.log(error);
          }
        }
      }
      resolve({
        status: error.response.status,
        data: error.response?.data?.message,
      });
    }
  });
  return data;
};
const deleteData = async (fields, ulr, id, dispatch, navigate, headers) => {
  const data = new Promise(async (resolve, reject) => {
    try {
      let token = GetAccessToken();
      const formData = new FormData();
      Object.entries(fields).forEach(([key, value]) => {
        if (typeof value === "object") {
          formData.append(key, value[0]);
        } else {
          formData.append(key, value);
        }
      });
      if(id){
        const response = await axios.delete(`${process.env.REACT_APP_API}${ulr}/${id}?lang=${sessionStorage.getItem("_lang") ? sessionStorage.getItem("_lang") : "de" }`, {
          headers: { "x-access-token": token, ...((sessionStorage.getItem("selected-company") && sessionStorage.getItem("user") && JSON.parse(sessionStorage.getItem("user")).user.authorisation === "advisor" && JSON.parse(sessionStorage.getItem("user")).user.company && JSON.parse(sessionStorage.getItem("user")).user.company !== null)
            ? { "x-company-id": sessionStorage.getItem("selected-company") }
            : {}), ...(headers ? headers : {}) },
        });
        if (response.status === 401) {
          try {
            dispatch(clearLogin());
            navigate("/");
            navigate(0);
          } catch (error) {
            // console.log(error);
          }
        }
        resolve({ status: response.status, data: response.data });
      }
      else{
        const response = await axios.delete(`${process.env.REACT_APP_API}${ulr}`, {
          headers: { "x-access-token": token },
        });
        if (response.status === 401) {
          try {
            dispatch(clearLogin());
            navigate("/");
            navigate(0);
          } catch (error) {
            // console.log(error);
          }
        }
        resolve({ status: response.status, data: response.data });
      }
     
    } catch (error) {
      // console.log("API Eror", error.message);
      resolve({
        status: error.response.status,
        data: error.response?.data?.message,
      });
    }
  });

  return data;
};
export { getData, postData, putData, deleteData, bulkUploadData };
